const ViewTypes = {
    DIVISION: {
        key: 'division',
        label: 'Division'
    },
    WILDCARD: {
        key: 'wildcard',
        label: 'Wild Card'
    },
    CONFERENCE: {
        key: 'conference',
        label: 'Conference'
    },
    LEAGUE: {
        key: 'league',
        label: 'League'
    }
};

export default ViewTypes;